// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__34PMA","colMaxWidth":"Table_colMaxWidth__3gOb2"};